<!-- eslint-disable -->
<template>
  <div v-if="isInitiailized === true" class="G_modal">

    <modal-header
      @event-close-child-modals="eventCloseChildModals"
      @event-close-modal="selfClose"
      :title="modalTitle">
    </modal-header>
      <div>
        <iframe class="p2s3m1_iframe" :src="iframeUrl">
        </iframe>
      </div>
  </div>
</template>

<script>
/* eslint-disable */
import {bi10ModalTemplate } from "../../../watchdog_includes/base_i10_UI_mixins";
import ModalHeader from "../p2ModalHeader";

export default {
  name: 'p2s3m1BillingSettings',
  components: {
    ModalHeader
  },
  mixins: [bi10ModalTemplate],
  data: function () {
    return {
      modalTitle:"Billing Settings",
      iframeUrl: window.G_ajax_test_domain + '/console/account_charge.html'
    }
  },
  methods: {
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s3accountSettings/p2s3m1BillingSettings.vue